import { render, staticRenderFns } from "./expert_manage.vue?vue&type=template&id=8b943808&scoped=true"
import script from "./expert_manage.vue?vue&type=script&lang=js"
export * from "./expert_manage.vue?vue&type=script&lang=js"
import style0 from "./expert_manage.vue?vue&type=style&index=0&id=8b943808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b943808",
  null
  
)

export default component.exports